import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#insurance-app', App);
